import axios from 'axios';
import config from '../config';

// TODO: authenticates with social media

/**
 * Authenticate a given user by email and password.
 *
 * @param {string} email - user's email
 * @param {string} pass - user's password
 *
 * @return {object} - A user object https://api.luxtag.io:8443/apidoc/#api-Auth-Authenticate
 */

function emailPw(email, pass) {
  if (arguments.length < 2 || (email === '' || pass === '')) {
    throw new Error('Missing argument in authRequest');
  } else {
    return axios({
      method: 'POST',
      baseURL: config.host,
      url: '/auth/local',
      timeout: config.timeout,
      data: {
        identifier: email,
        password: pass,
      },
    });
  }
}

export default {
  emailPw: emailPw,
};



// WEBPACK FOOTER //
// ./src/API/Auth/auth.js